// extracted by mini-css-extract-plugin
export default {"heading":"TwoFactorAuth_heading__Tr-5h","wrapper":"TwoFactorAuth_wrapper__v-55y"};